export default "__VITE_ASSET__0d97f7b2__"